import styled from 'styled-components';

type SegmentedControlOption<T extends string> = {
    value: T;
    label: string;
};

type SegmentedControlProps<T extends string> = {
    options: SegmentedControlOption<T>[];
    value: T;
    onChange: (value: T) => void;
};

export const SegmentedControl = <T extends string>({ options, value, onChange }: SegmentedControlProps<T>) => {
    return (
        <Container>
            {options.map((option) => (
                <Button key={option.value} $isActive={option.value === value} onClick={() => onChange(option.value)}>
                    {option.label}
                </Button>
            ))}
        </Container>
    );
};

const Container = styled.div`
    display: inline-flex;
    border-radius: ${({ theme }) => theme.borderRadius};
    overflow: hidden;
    border: 1px solid ${({ theme }) => theme.lightBorderColor};
`;

const Button = styled.button<{ $isActive: boolean }>`
    padding: 8px 16px;
    border: none;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.2s ease;

    background-color: ${({ theme, $isActive }) => ($isActive ? theme.ctaPrimaryColor : theme.backgroundColor)};
    color: ${({ theme, $isActive }) => ($isActive ? theme.ctaPrimaryTextColor : theme.textColor)};

    &:not(:last-child) {
        border-right: 1px solid ${({ theme }) => theme.lightBorderColor};
    }

    &:hover {
        background-color: ${({ theme, $isActive }) =>
            $isActive ? theme.ctaPrimaryHoveredColor : theme.ctaPrimaryBorderColor};
    }
`;
